import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-diploma-verified',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="class">
                <path
                    opacity="0.5"
                    d="M5.5 3.5H18.5C19.3284 3.5 20 4.17157 20 5V13C20 13.8284 19.3284 14.5 18.5 14.5H5.5C4.67157 14.5 4 13.8284 4 13V5C4 4.17157 4.67157 3.5 5.5 3.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                />
                <path opacity="0.5" d="M8 7H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path opacity="0.5" d="M8 9.5H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path opacity="0.5" d="M8 12H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                <path
                    d="M12 14.35L12.42 15.22L13.38 15.08L12.96 15.9L13.78 16.52L12.82 16.86L12.42 17.82L12 16.86L11.58 17.82L11.18 16.86L10.22 16.52L11.04 15.9L10.62 15.08L11.58 15.22L12 14.35Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linejoin="round"
                />
                <path
                    d="M10.75 16.65L11.55 17.45L13.35 15.65"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </ng-template>
    `,
})
export class IconDiplomaVerifiedComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
